import ScrollTo from "@stimulus-components/scroll-to";

export default class extends ScrollTo {
  get defaultOptions() {
    return {
      offset: 80,
      behavior: "smooth"
    };
  }
}



